'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { getNewsPage } from '@/services/sanity/api/get-news-list';
import CenteredColumn from '@/ui/segments/landing/components/centered-column';
import { styleBlockMedium, styleButtonRounded } from '@/ui/segments/landing/styles';
import { classNames } from '@/util/utils';
import Card from './card';
import CategoryButton from './category-button';
import type { ContentForNewsList } from '@/services/sanity/api/get-news-list';
import styles from './section-news.module.css';
interface SectionNewsProps {
  className?: string;
  showHeader?: boolean;
  initialNews: ContentForNewsList;
  totalCount: number;
}
const PAGE_SIZE = 10;
export default function SectionNews(t0) {
  const $ = _c(38);
  const {
    className,
    showHeader: t1,
    initialNews,
    totalCount
  } = t0;
  const showHeader = t1 === undefined ? false : t1;
  const [newsList, setNewsList] = React.useState(initialNews);
  const [loading, setLoading] = React.useState(false);
  const [categories, setCategories] = React.useState(ALL_CATEGORY_IDS);
  let t2;
  if ($[0] !== loading || $[1] !== newsList.length || $[2] !== totalCount) {
    t2 = async () => {
      if (loading || newsList.length >= totalCount) {
        return;
      }
      setLoading(true);
      const page = await getNewsPage(newsList.length, PAGE_SIZE);
      if (page.length > 0) {
        setNewsList(prev => [...prev, ...page]);
      }
      setLoading(false);
    };
    $[0] = loading;
    $[1] = newsList.length;
    $[2] = totalCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleLoadMore = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setCategories(ALL_CATEGORY_IDS);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSwitchAll = t3;
  let t4;
  if ($[5] !== categories) {
    t4 = catId => {
      if (categories.includes(catId)) {
        setCategories(categories.filter(id => id !== catId));
      } else {
        setCategories([...categories, catId]);
      }
    };
    $[5] = categories;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSwitchCat = t4;
  let remainingCount;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[7] !== categories || $[8] !== className || $[9] !== handleSwitchCat || $[10] !== newsList || $[11] !== showHeader || $[12] !== totalCount) {
    const newsListOBI = newsList.filter(_temp);
    const newsListEPFL = newsList.filter(_temp2);
    remainingCount = Math.min(PAGE_SIZE, totalCount - newsList.length);
    if ($[18] !== className) {
      t5 = classNames(className, styles.news, styleBlockMedium);
      $[18] = className;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    if ($[20] !== categories || $[21] !== handleSwitchCat || $[22] !== showHeader) {
      t6 = showHeader && <header><div className={styles.label}>Filter by</div><CategoryButton selected={categories.length === CATEGORIES.length} onClick={handleSwitchAll}>All</CategoryButton><div className={styles.buttons}>{CATEGORIES.map(cat => <CategoryButton key={cat.id} onClick={() => handleSwitchCat(cat.id)} selected={categories.includes(cat.id)}>{cat.label}</CategoryButton>)}</div></header>;
      $[20] = categories;
      $[21] = handleSwitchCat;
      $[22] = showHeader;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    const t9 = newsListOBI.map(_temp3);
    if ($[24] !== t9) {
      t7 = <main>{t9}</main>;
      $[24] = t9;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    t8 = newsListEPFL.length > 0 && <div className={styles.epflNews}><h1 className={styles.separator}>BBP news highlight</h1><div className={styles.copyright}>Copyright © EPFL - BBP</div><hr className={styles.separator} /><div className={styles.epfl}>{newsListEPFL.map(_temp4)}</div></div>;
    $[7] = categories;
    $[8] = className;
    $[9] = handleSwitchCat;
    $[10] = newsList;
    $[11] = showHeader;
    $[12] = totalCount;
    $[13] = remainingCount;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    remainingCount = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
  }
  let t9;
  if ($[26] !== handleLoadMore || $[27] !== loading || $[28] !== newsList.length || $[29] !== remainingCount || $[30] !== totalCount) {
    t9 = newsList.length < totalCount && <CenteredColumn><button type="button" data-testid="news-load-more" className={styleButtonRounded} onClick={handleLoadMore} disabled={loading}>Load {remainingCount} more article{remainingCount > 1 ? "s" : ""}</button></CenteredColumn>;
    $[26] = handleLoadMore;
    $[27] = loading;
    $[28] = newsList.length;
    $[29] = remainingCount;
    $[30] = totalCount;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t10 = <div className={t5}>{t6}{t7}{t8}{t9}</div>;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}
function _temp4(item_2) {
  return <Card key={item_2.id} news={item_2} />;
}
function _temp3(item_1) {
  return <Card key={item_1.id} news={item_1} />;
}
function _temp2(item_0) {
  return item_0.isEPFL;
}
function _temp(item) {
  return !item.isEPFL;
}
const CATEGORIES: Array<{
  id: string;
  label: string;
}> = [{
  label: 'BBP news',
  id: 'BBP news'
}, {
  label: 'Talk',
  id: 'Talk'
}, {
  label: 'New feature',
  id: 'New feature'
}, {
  label: 'Paper release',
  id: 'Paper release'
}, {
  label: 'Platform update',
  id: 'Platform update'
}, {
  label: 'New model',
  id: 'New model'
}, {
  label: 'Event',
  id: 'Event'
}, {
  label: 'Workshop',
  id: 'Workshop'
}, {
  label: 'Knowledge',
  id: 'Knowledge'
}, {
  label: 'Milestone',
  id: 'Milestone'
}];
const ALL_CATEGORY_IDS = CATEGORIES.map(cat => cat.id);